import {combineReducers, createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiHost} from "../apiData";
import {getLanguage} from "../locales/langUtils";

export const executeLogoutFetch = createAsyncThunk(
    'loginFetch/executeLogoutFetch',
    async ({isInactive = false}, _) => {
        const endpointSuffix = isInactive ? 'inactivity-logout' : 'logout';
        const response = await fetch(`${apiHost}/api/user/${endpointSuffix}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': getLanguage()
            },
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Not authorized');
        }

        return response.json();
    });

export const logoutFetchSlice = createSlice(
    {
        name: 'logoutFetch',
        initialState: {
            isLoading: false,
            logoutActive: false
        },
        reducers: {
            setLogoutActive: (state, action) => {
                state.logoutActive = action.payload;
            }
        },
        extraReducers: (builder) => {
            builder.addCase(executeLogoutFetch.pending, state => {
                state.isLoading = true;
            }).addCase(executeLogoutFetch.fulfilled, (state, action) => {
                state.isLoading = false;
                window.location.href = action.payload.redirectUrl;
                state.logoutActive = false;
            }).addCase(executeLogoutFetch.rejected, state => {
                state.isLoading = false;
            })
        }
    }
)

export const executeLoginFetch = createAsyncThunk(
    'loginFetch/executeLoginFetch',
    async (_, {getState, rejectWithValue}) => {
        const state = getState().login.loginForm;
        const response = await fetch(`${apiHost}/api/user/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': getLanguage()
            },
            body: JSON.stringify({
                username: state.username,
                password: state.password
            }),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            return rejectWithValue(data);
        }

        return data;
    });

export const loginFormSlice = createSlice(
    {
        name: 'loginForm',
        initialState: {
            username: '',
            password: ''
        },
        reducers: {
            setUsername: (state, action) => {
                state.username = action.payload
            },
            setPassword: (state, action) => {
                state.password = action.payload
            }
        }
    });

export const loginFetchSlice = createSlice(
    {
        name: 'loginFetch',
        initialState: {
            isLoading: false,
            notAuthorized: false,
            errorData: null
        },
        reducers: {
            setErrorData: (state, action) => {
                state.errorData = action.payload;
            }
        },
        extraReducers: (builder) => {
            builder.addCase(executeLoginFetch.pending, state => {
                state.isLoading = true;
                state.notAuthorized = false;
            }).addCase(executeLoginFetch.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notAuthorized = false;
                window.location.href = action.payload.redirectUrl;
            }).addCase(executeLoginFetch.rejected, (state, action) => {
                state.isLoading = false;
                state.notAuthorized = true;
                state.errorData = action.payload
            })
        }
    }
)

export const {setUsername, setPassword} = loginFormSlice.actions;
export const {setErrorData} = loginFetchSlice.actions;
export const {setLogoutActive} = logoutFetchSlice.actions;

const loginReducer = combineReducers({
    loginForm: loginFormSlice.reducer,
    loginFetch: loginFetchSlice.reducer,
    logoutFetch: logoutFetchSlice.reducer
});

export default loginReducer;